module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/leads/css/lead-crud.component.css
// module id = ./src/app/modules/leads/css/lead-crud.component.css
// module chunks = main